module.exports = __webpack_public_path__ + "static/Submarkets_2021_Release_4-627f88391e96760c141b540a08fa5213.png";